import React from 'react';
import { MobileTableStyle } from '../styles';

export const MobileTable = ({ data, background }) => {

    return (
        <MobileTableStyle background={background}>
            <tbody>
               {
                   data.map(({ label, value }) => (
                       <tr key={label}>
                           <td>{label}</td>
                           <td>{value}</td>
                       </tr>
                   ))
               }
            </tbody>
        </MobileTableStyle>
    );
};

export default MobileTable;
